<template>
  <div
    class="z-50 inset-0 fixed bg-black opacity-50 flex items-center justify-center lg:ml-38 xl:ml-26 h-screen md:ml-0 md:min-h-screen"
    v-if="loading"
  >
    <Lynx-Spinner size="14" />
  </div>
</template>

<script>
export default {
  props: ["loading"],
};
</script>
